@if(!mapOnly){
<mat-toolbar class="content-header">
  <h1 class="maps-title">
    <mat-icon fontIcon="map"></mat-icon>
    {{'viewer.maps' | translate}}
  </h1>

  <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="viewer-google-map moving viewer" [ngClass]="{ 'timeline': showTimeline }">
  <google-map appMapTheme [width]="null" [height]="null" [options]="mapOptions" id="google-map" #mapContainer>
  </google-map>

  <app-tracker-position class="floating-window" *ngIf="showTrackerPosition" [trackers]="trackers" cdkDrag
    (submit)="submitTrackerPosition($event)" (close)="closeTrackerPosition()" (located)="updateGeolocationIcon($event)"
    [accuracy]="project()?.geolocation?.accuracy || 4" [duration]="project()?.geolocation?.duration || 10">
  </app-tracker-position>

  <app-coordinate *ngIf="showFloatingWindow" [liveState]="liveState" [clickedMarkerInfo]="clickedMarkerInfo"
    (saveData)="handleSaveData($event)" (close)="closeFloatingWindow()">
  </app-coordinate>

  <!-- Floating Zone Editing -->
  <div *ngIf="editingZone" class="floating-window zone-edit-panel" cdkDrag>
    <div *ngIf="currentZone()">
      <div class="dialog-title">
        <h2 class="title">
          <span class="title-icon">
            <mat-icon>edit</mat-icon>
          </span>
          {{'viewer.zone.editing'|translate}}
        </h2>

        <lib-button (click)="cancelEditZone()" icon="close" color="none" textColor="muted"
          tooltip="{{'viewer.close'|translate}}">
        </lib-button>
      </div>

      <form [formGroup]="zoneForm" class="zone-form">
        <!-- Name -->
        <mat-form-field appearance="outline" class="zone-input">
          <mat-label>{{'groups.name'|translate}}</mat-label>
          <input matInput type="text" formControlName="name">
        </mat-form-field>

        <!-- Colors -->
        <mat-form-field appearance="outline" class="zone-input">
          <mat-label>{{'form.color'|translate}}</mat-label>

          <mat-select formControlName="color" class="color-select">
            <mat-select-trigger>
              <div class="color-display">
                <span class="color-circle" [style.background-color]="getColorHex(getSelectedColorValue())"></span>
                {{ getSelectedColorTitle() }}
              </div>
            </mat-select-trigger>

            <mat-option *ngFor="let color of zoneColors()" [value]="color.value">
              <span class="color-circle" [style.background-color]="getColorHex(color.value)"></span>
              {{ color.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="section-title">{{'geometry.position'|translate}}</div>
        <div class="row">
          <!-- Z -->
          <mat-form-field appearance="outline" class="number-input">
            <mat-label>Z</mat-label>
            <input matInput type="number" [(ngModel)]="currentZone().z" [ngModelOptions]="{standalone: true}" step="1"
              (change)="onZonePointUpdate()">
          </mat-form-field>

          <!-- Height -->
          <mat-form-field appearance="outline" class="number-input">
            <mat-label>{{'geometry.height'|translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="currentZone().height" [ngModelOptions]="{standalone: true}"
              step="1" (change)="onZonePointUpdate()">
          </mat-form-field>
        </div>

        @if(editingPoint){
        <fieldset class="point-fieldset">
          <legend>
            <mat-icon>place</mat-icon>
            {{'viewer.zone.selected_point' | translate}}
          </legend>

          <div class="row">
            <mat-form-field appearance="outline" class="number-input">
              <mat-label>
                {{'viewer.lon'|translate}}
              </mat-label>

              <input matInput type="number" [(ngModel)]="editingPoint.lng" id="longitude" step="0.0001"
                [ngModelOptions]="{standalone: true}" (change)="onZonePointUpdate()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="number-input">
              <mat-label>
                {{'viewer.lat'|translate}}
              </mat-label>

              <input matInput type="number" [(ngModel)]="editingPoint.lat" id="latitude" step="0.0001"
                [ngModelOptions]="{standalone: true}" (change)="onZonePointUpdate()">
            </mat-form-field>

            <lib-button [matMenuTriggerFor]="pointMenu" color="none" textColor="secondary" icon="more_vert"
              matTooltip="Options">
            </lib-button>

            <mat-menu #pointMenu="matMenu" class="point-menu">
              <button mat-menu-item class="menu-item" (click)="openTrackerPosition()">
                <mat-icon>my_location</mat-icon>
                <span>{{'units.tracker_pos.from_tracker' | translate}}</span>
              </button>

              <button mat-menu-item class="menu-item" (click)="useUnitPosition = true">
                <mat-icon>location_on</mat-icon>
                <span>{{'units.unit_pos.from_unit' | translate}}</span>
              </button>

              <button mat-menu-item class="menu-item" (click)="deletePoint()">
                <mat-icon>delete</mat-icon>
                <span>{{'form.delete' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </fieldset>
        }

        <div class="row">
          <app-date-picker [label]="'datatable.startDate' | translate" class="zone-date" id="startDate"
            [startDate]="currentZone().startDate" (stateChanged)="onZoneDateChanged($event)" [hideTime]="true"
            [max]="null">
          </app-date-picker>

          <app-date-picker [label]="'datatable.endDate' | translate" class="zone-date" id="endDate"
            [startDate]="currentZone().endDate" (stateChanged)="onZoneDateChanged( $event)" [hideTime]="true"
            [max]="null">
          </app-date-picker>
        </div>

        <div class="action-btn">
          <div class="action-group">
            <lib-button color="none" textColor="primary" icon="save" tooltip="{{'form.save' | translate}}"
              (click)="saveZone(currentZone())">
            </lib-button>

            <lib-button color="none" textColor="secondary" icon="control_camera" tooltip="{{'form.move' | translate}}"
              (click)="editZone(currentZone())">
            </lib-button>

            <lib-button color="none" textColor="tertiary" icon="content_copy" tooltip="{{'form.copy' | translate}}"
              (click)="duplicateZone(currentZone())">
            </lib-button>
          </div>

          <lib-button color="none" textColor="danger" icon="delete" tooltip="{{'form.delete' | translate}}"
            (click)="deleteZone(currentZone())">
          </lib-button>
        </div>
      </form>
    </div>
  </div>

  <mat-card class="floating-window" cdkDrag *ngIf="showLastAttachment">
    <div class="dialog-title">
      <h3 class="title">
        <mat-icon fontIcon="photo_camera"></mat-icon>
        {{'viewer.last_picture'|translate}}
      </h3>

      <span class="spacer"></span>

      <mat-form-field appearance="outline" class="select-tracker" subscriptSizing="dynamic">
        <mat-label>
          {{'trackers.title'|translate}}
        </mat-label>

        <mat-select>
          <mat-option *ngFor="let prediction of pAttachments" [value]="prediction.tracker"
            (click)="loadPredictions(getTrackerId(prediction.tracker))">
            {{prediction.trackerName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <lib-button color="none" textColor="muted" icon="close" tooltip="{{'viewer.close'|translate}}"
        (click)="cameraBtn()">
      </lib-button>
    </div>

    <div *ngIf="!lastAttachment" class="mat-card-image">
      <h3>{{'viewer.no_last_picture'|translate}}</h3>
    </div>

    <ng-container *ngIf="lastAttachment">
      <img mat-card-image class="mat-card-image" [src]="lastAttachment.url" (click)="onImageClick(0, [lastAttachment])">

      <div class="recognition-title">
        <span>{{'viewer.recognitions'|translate}}</span>
      </div>

      <mat-card-content class="prediction-color">
        <span *ngFor="let item of lastPredictions">{{item.tagName}}: {{item.probability}}% <br></span>
      </mat-card-content>
    </ng-container>
  </mat-card>

  <div class="viewer-button">
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
      <ng-container *ngIf="user() && user().role && user().role.name !== 'guest'">
        <mat-button-toggle (click)="traceUnitModal()">
          <mat-icon fontIcon="devices_other"></mat-icon>
          @if(!isMobileSignal()) {
          {{'viewer.unit_trace'|translate}}
          }
        </mat-button-toggle>

        <mat-button-toggle (click)="zoneModal()">
          <mat-icon fontIcon="layers"></mat-icon>
          @if(!isMobileSignal()) {
          {{'viewer.zones'|translate}}
          }
        </mat-button-toggle>

        <mat-button-toggle (click)="originModal()">
          <mat-icon fontIcon="location_on"></mat-icon>
          @if(!isMobileSignal()) {
          {{'viewer.origin'|translate}}
          }
        </mat-button-toggle>

        <mat-button-toggle (click)="overlayModal()">
          <mat-icon fontIcon="image"></mat-icon>
          @if(!isMobileSignal()) {
          Overlay
          }
        </mat-button-toggle>
      </ng-container>

      <mat-button-toggle (click)="centerBtn()">
        <mat-icon fontIcon="center_focus_strong"></mat-icon>
        @if(!isMobileSignal()) {
        {{'viewer.center'|translate}}
        }
      </mat-button-toggle>

      <mat-button-toggle (click)="cameraBtn()">
        <mat-icon fontIcon="photo_camera"></mat-icon>
        @if(!isMobileSignal()) {
        {{'viewer.camera'|translate}}
        }
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<app-confirm-map *ngIf="editingImage" [data]="currentImage" [editedData]="editedImage" (saveData)="handleSaveImage()"
  (cancel)="cancelEditImage($event)" (rotation)="rotationImage($event)" (opacity)="onImageOpacityChanged($event)"
  (opacityCommit)="onImageOpacityCommit($event)" [title]="titleImage" icon="transform"
  [angle]="getAngle(editedImage()) ?? 0">
</app-confirm-map>

<app-player [units]="units" [replayUnitNames]="replayUnitNames" (onPlayerChanged)="onPlayerChanged($event)"
  (onTrackerPositionsChanged)="onTrackerPositionsChanged($event)" class="{{ showTimeline ? 'timeline' : ''}}"
  [activity]="activitySignal()">
</app-player>

<div *ngIf="showContextMenu && zoneCreator" class="context-menu" [style.left]="menuPosition.x + 'px'"
  [style.top]="menuPosition.y + 'px'" (contextmenu)="onContextMenuClose()">
  <div class="menu-item" (click)="deletePoint()"
    [ngClass]="{ 'disabled': !zoneEditor || zoneEditor.points.length <= 3 }">
    <mat-icon class="delete" fontIcon="delete_forever"></mat-icon>

    <div class="menu-item-text">
      {{ 'form.delete'|translate }}
    </div>
  </div>

  <div class="menu-item trigger-element">
    <mat-icon class="delete" fontIcon="edit"></mat-icon>

    <div class="menu-item-text">
      {{ 'form.update'|translate }}
    </div>

    <mat-icon fontIcon="arrow_right"></mat-icon>

    <div class="submenu">
      <div class="menu-item">
        <mat-icon class="delete" fontIcon="my_location"></mat-icon>

        <div class="menu-item-text">
          {{ 'Use tracker position'|translate }}
        </div>
      </div>

      <div class="menu-item">
        <mat-icon class="delete" fontIcon="my_location"></mat-icon>

        <div class="menu-item-text">
          {{ 'Use unit position'|translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<app-context-menu *ngIf="showContextMenu && zoneEditor" [items]="menuItems" [position]="menuPosition"
  (onClose)="onContextMenuClose()" [container]="mapRect">
</app-context-menu>
}
@else {
<div class="viewer-google-map moving viewer">
  <google-map appMapTheme [width]="null" [height]="null" [options]="mapOptions" id="google-map" #mapContainer>
  </google-map>

  <div id="maps-rendered" *ngIf=""></div>
</div>
}